import { state } from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const mdm = {
  state,
  mutations,
  actions,
  getters
};

export default mdm;
